export enum PostFilter {
  SENDER = '93bfe74f-38df-4475-94c4-c722fffe42e5',
  RECEIVER = '96a3515f-cef2-4252-9994-ee81d5c888ea',
  POST_TEXT = 'ecd6a532-0132-4e64-8a56-cab149ea06ce',
  HIGHLIGHTED = 'fbfc192d-a594-4a9b-9fd3-fafe95dbc72d',
  SENDER_HIMSELF = '6a25945d-d71c-46e1-8846-716a7b7fa6d2',
  TOP_POSTERS = '4ea5e130-f422-4919-9aa3-34c0af2c5b9d',
}

export enum ScreenTypes {
  ONLY_COMMUNITY = 'af46cd5e-ed9c-4efe-a968-aa9291a50ce2',
  ONLY_HOME = 'd0dc7ac9-37df-480d-ab2f-9ae4d8c6f65a',
}
